<!-- 对方业务员操作 -->
<template>
    <div>
        <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                    <template slot="tabs" slot-scope="scope">
                        <div class="table_content_box">
                            <!-- 主要信息 -->
                            <div v-if="scope.index == 0">
                                <el-form label-width="150px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                    <el-row v-if="dataActionBox.actionType != 2">
                                        <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                            <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField"
                                                          :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <!-- 日期 -->
                                                <df-date :isType="true" v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneKey)"
                                                         :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                </df-date>
                                                <!-- 检索方案 -->
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                              :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-select clearable size="mini" @visible-change="selectChange" v-else-if="formOneValue.entityField == 'salesmanType'" @change="changeUnit"
                                                           :disabled="formOneValue.isChange == 0" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                                                    </el-option>
                                                </el-select>
                                                <el-radio-group v-else-if="formOneValue.entityField == 'isIntercept'" v-model="sendDataInfo.isIntercept">
                                                    <el-radio-button :label="0">否</el-radio-button>
                                                    <el-radio-button :label="1">是</el-radio-button>
                                                </el-radio-group>
                                                <el-radio-group v-else-if="formOneValue.entityField == 'isUsed'" v-model="sendDataInfo.isUsed">
                                                    <el-radio-button :label="0">否</el-radio-button>
                                                    <el-radio-button :label="1">是</el-radio-button>
                                                </el-radio-group>
                                                <el-select v-else-if="formOneValue.entityField == 'terName'" v-model="sendDataInfo.terName" style="width: 100%;" clearable>
                                                    <el-option v-for="(values) in dictionariesDatas" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                                                </el-select>
                                                <el-radio-group v-else-if="formOneValue.entityField == 'terType'" v-model="sendDataInfo.terType" @change="changeTerType">
                                                    <el-radio-button :label="1">单品委托</el-radio-button>
                                                    <el-radio-button :label="0">全品委托</el-radio-button>
                                                </el-radio-group>
                                                <el-select clearable size="mini" v-else-if="formOneValue.entityField == 'terScope'" :disabled="formOneValue.isChange == 0" @change="$forceUpdate()"
                                                           v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                                                    </el-option>
                                                </el-select>
                                                <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                <el-select clearable size="mini" @visible-change="selectChange" v-else-if="formOneValue.fieldType == 'formatter' && formOneValue.entityField != 'salesmanType'"
                                                           :disabled="formOneValue.isChange == 0" @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                                                    </el-option>
                                                </el-select>
                                                <!-- 地域限制 -->
                                                <el-select v-else-if="formOneValue.entityField == 'geogRest'" @visible-change="selectChange" v-model="sendDataInfo.geogRest" style="width: 100%;" clearable>
                                                    <el-option v-for="(values) in geogRestData" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                                                </el-select>
                                                <el-input @keyup.enter.native="nextFocus(formOneKey)" v-else-if="formOneValue.entityField == 'salesNumber'" :disabled="formOneValue.isChange == 0"
                                                          v-model.trim="sendDataInfo[formOneValue.entityField]">
                                                    <template slot="append">
                                                        <span style="color: red;">
                                                            {{ sendDataInfo[formOneValue.entityField] ==''|| sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField]== undefined ? 0 : sendDataInfo[formOneValue.entityField].length }}位
                                                        </span>
                                                    </template>
                                                </el-input>
                                                <!-- string类型 -->
                                                <el-input @keyup.enter.native="nextFocus(formOneKey)" v-else-if="formOneValue.entityField == 'phone'" :disabled="formOneValue.isChange == 0"
                                                          v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength">
                                                    <template slot="append">
                                                        <span style="color: red;">
                                                            {{ sendDataInfo[formOneValue.entityField] ==''|| sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField]== undefined ? 0 : sendDataInfo[formOneValue.entityField].length }}位
                                                        </span>
                                                    </template>
                                                </el-input>
                                                <div v-else-if="formOneValue.entityField == 'filePath'">
                                                    <input style="display: none;" type="file" id="recordExcel" multiple name="recordExcel" @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e) }" />
                                                    <div>
                                                        <label for="recordExcel" class="image_label">上传</label>
                                                        <el-button @click.stop="openFile1()" type="primary" size="mini">高拍仪</el-button>
                                                    </div>
                                                    <ul v-if="sendDataInfo[formOneValue.entityField]" class="upload">
                                                        <li v-for="(val, key) in sendDataInfo[formOneValue.entityField].split(',')" :key="key">
                                                            <i class="el-icon-error del" @click="delRemove(key)"></i>
                                                            <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="sendDataInfo[formOneValue.entityField].split(',').map(item => `${imgUrl}/${item}`)">
                                                            </cusImage>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <el-input @keyup.enter.native="nextFocus(formOneKey)" v-else :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                          :maxlength="$store.state.inputLength"></el-input>
                                            </el-form-item>
                                        </template>
                                    </el-row>
                                    <el-row v-if="dataActionBox.actionType == 2">
                                        <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                            <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" :key="formOneKey">
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">
                                                        {{ sendDataInfo[formOneValue.entityField] }}
                                                    </a>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                    </span>
                                                </span>
                                                <span v-else-if="formOneValue.entityField == 'salesmanType'">
                                                    {{ sendDataInfo.salesmanType == 0 ? '客户' : '供应商' }}
                                                </span>
                                                <div v-else-if="formOneValue.entityField == 'filePath'">
                                                    <ul v-if="sendDataInfo[formOneValue.entityField]" class="upload">
                                                        <li v-for="(val, key) in JSON.parse(sendDataInfo.filePath)" :key="key">
                                                            <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                                            </cusImage>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span
                                                      v-else-if="formOneValue.fieldType == 'formatter' || formOneValue.entityField == 'geogRest' || formOneValue.entityField == 'terType' || formOneValue.entityField == 'isIntercept' || formOneValue.entityField == 'isUsed'">
                                                    {{getValue(sendDataInfo[formOneValue.fieldEntity], formOneValue.fieldEntity,formOneValue.fieldType, formOneValue.formatterContent)}}
                                                </span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </template>
                                    </el-row>
                                </el-form>
                                <div v-if="sendDataInfo.terType == 1">
                                    <div style="margin:.6rem 0" v-if="dataActionBox.actionType != 2">
                                        <el-button type="primary" size="mini" @click="openSearch('853533363572736')">新增单品
                                        </el-button>
                                        <el-button type="primary" size="mini" @click="delLicense()">删除单品</el-button>
                                    </div>
                                    <el-table :data="sendDataInfo.descibSalesplicencedetailVo" ref="mxTableRef" id="mxTable" :height="mxHeight" border style="width: 100%" size="mini">
                                        <el-table-column label="选择操作" width="90">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <template v-for="(formOneValue, formOneKey) in mxForm">
                                            <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" :min-width="formOneValue.fieldWeight" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row[formOneValue.entityField] }}</span>
                                                </template>
                                            </el-table-column>
                                        </template>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                    </template>
                </v-tabs>
            </el-card>
            <div class="foot">
                <div>
                    <el-button v-if="dataActionBox.actionType != 2" type="primary" @click="cancelAdd('sendDataInfo')">取消
                    </el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
                </div>
            </div>
        </div>
        <!-- 检索方案 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 检索方案弹窗 -->
        <el-dialog :title="seTitle" v-if="DialogVisible1" :visible.sync="DialogVisible1" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchSchemeMultiple ref="searchSchemeMultiple" :id="seId" :parentSearchData="parentSearchData" :parentData="parentData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="DialogVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="getSelect">确认选择</el-button>
            </span>
        </el-dialog>
        <FileNewAction ref="FileNewAction" v-if="showFile" :showFile="showFile" @isshowFile="IsshowFile" @NewelectFileIds="changeFileIds"></FileNewAction>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
    name: "salesmanAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            seTitle: "", //检索
            searchDialogVisible: false,
            seWidth: 0,
            seId: 0,
            geogRestData: [],
            tabForm: [],
            mxForm: [],
            tabForm1: [],
            footForm: [],
            showTabs: '',
            formDataList: [],
            DialogVisible: false,
            seId: '',
            seIndex: 0,
            seType: '',
            sField: '',
            fField: '',
            nosField: '',
            parentSearchData: {},
            mxHeight: 400,
            selectedDetailsIndex: 0,
            imgUrl: '',
            dictionariesDatas: [],
            //------------
            showFile: false,
            //------------
            DialogVisible1: false,
            parentData: {
                type: "bgmId",
                list: [],
            },
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        // "sendDataInfo.salesmanType": {
        //   handler(newValue, oldVal) {},
        // },
        "sendDataInfo.salesName"() {
            //获取助记码
            this.sendDataInfo.salesMne = this.$common.createPinyinCode(
                this.sendDataInfo.salesName,
                this.sendDataInfo.salesMne
            );
        },
    },
    //方法集合
    methods: {
        changeTerType() {
            console.log(this.sendDataInfo.terType);
            this.tabForm.forEach(item => {
                console.log(item, "测试");

                item.jurconfigform.forEach(item1 => {
                    if (item1.entityField == 'terScope') {
                        if (this.sendDataInfo.terType == 0) {
                            item1.isShow = 1
                        } else {
                            item1.isShow = 0
                        }
                    }
                })

            })
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            var value = ""
            if (String(Number(val)) != NaN) {
                value = Number(val)
            } else {
                value = val
            }
            if (type == 'isIntercept') {
                this.sendDataInfo.isIntercept = value == 1 ? '是' : '否'
            } else if (type == 'isUsed') {
                this.sendDataInfo.isUsed = value == 1 ? '是' : '否'
            } else if (type == 'terType') {
                this.sendDataInfo.terType = value == 1 ? '单品委托' : '全品委托'
            } else if (type == 'geogRest') {
                if (this.geogRestData) {
                    this.geogRestData.forEach(item => {
                        if (item.diId == value) {
                            str = item.diName
                        }
                    })
                }
            } else if (fieldType == 'formatter') {
                if (arr && arr != null && arr != '') {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && Number(item.value) === value) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && Number(item.key) === value) {
                            str = item.value
                        } else {
                            if (item.value == value) {
                                str = item.key
                            } else if (item.key == value) {
                                str = item.value
                            }
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        delRemove(index) {
            if (!this.sendDataInfo.filePath) {
                return; // filePath 为空或未定义，直接返回
            }
            const arr = this.sendDataInfo.filePath.split(",");
            arr.splice(index, 1); // 从数组中移除指定索引的元素
            this.sendDataInfo.filePath = arr.join()
        },
        async fileUpload(files, length, index, e) {
            if (length - 1 >= index) {
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadFile(params, true)
                if (response.status == 200) {
                    var arr = []
                    if (this.sendDataInfo.filePath) {
                        arr = this.sendDataInfo.filePath.split(",")
                    }
                    arr.push(response.result[0].fileUrl)
                    this.sendDataInfo.filePath = arr.join()
                    this.fileUpload(files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        openFile1() {//打开高拍仪组件
            this.showFile = true
        },
        IsshowFile(value) {
            this.showFile = value
        },
        changeFileIds(val) {
            var arr = []
            if (this.sendDataInfo.filePath) {
                arr = this.sendDataInfo.filePath.split(",")
                val.forEach(item => {
                    arr.push(item.fileUrl);
                })
            } else {
                val.forEach(item => {
                    arr.push(item.fileUrl);
                })
            }
            this.sendDataInfo.filePath = arr.join()
            this.showFile = false
        },
        //删除单品
        delLicense() {
            if (this.sendDataInfo.descibSalesplicencedetailVo.length < 1) {
                this.$message({
                    message: "请先添加单品",
                    type: "error",
                });
                return false;
            }
            this.sendDataInfo.descibSalesplicencedetailVo.splice(this.selectedDetailsIndex, 1);
            if (this.sendDataInfo.descibSalesplicencedetailVo.length<=this.selectedDetailsIndex) {
                this.selectedDetailsIndex = this.sendDataInfo.descibSalesplicencedetailVo.length-1;
            }
        },
        //
        getSelect() {
            var mx = JSON.parse(JSON.stringify(this.$refs.searchSchemeMultiple.multipleSelection))
            console.log(mx);

            this.sendDataInfo.descibSalesplicencedetailVo = mx
            this.DialogVisible1 = false;
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index)
                        break
                    }
                }
            }
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) {
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        checkNumber() {
            const reg =
                /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/;
            const isCard = reg.test(this.sendDataInfo.salesNumber);
            // value = Number(value);
            if (!isCard) {
                this.sendDataInfo.salesNumber = ''
                return this.$message({
                    type: 'warning',
                    message: '身份证号码不合法，请重新输入'
                });
            }
        },
        tableRowClassName({
            row,
            rowIndex
        }) {
            return 'success-row';
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                console.log(this.actionData);
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        // 修改类型改变单位
        changeUnit(data) {
            console.log(data)
            this.sendDataInfo.unitId = "";
            this.sendDataInfo.unitName = "";
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, nosField) {
            if (sId == '853533363572736') {
                this.seId = sId
                if (this.sendDataInfo.descibSalesplicencedetailVo && this.sendDataInfo.descibSalesplicencedetailVo.length > 0) {
                    this.parentData.list = this.sendDataInfo.descibSalesplicencedetailVo
                }
                this.DialogVisible1 = true;
                return
            }
            if (this.sendDataInfo.salesmanType != 0 && this.sendDataInfo.salesmanType != 1) return this.$message({
                message: "请先选择业务员类型",
                type: "warning",
            });
            this.seId =
                this.sendDataInfo.salesmanType == 0 ?
                    "157783642640384" :
                    "155784192757760"; //	业务员类型0 客户 1供应商
            this.DialogVisible = true;
            // this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.fField = fField
            this.nosField = nosField
            if (type == 'unitName') {
                if (this.sendDataInfo.salesmanType == 0) {
                    this.parentSearchData['cmName'] = this.sendDataInfo['unitName']
                } else {
                    this.parentSearchData['smName'] = this.sendDataInfo['unitName']
                }
            } else {
                this.parentSearchData[type] = this.sendDataInfo[type]
            }
        },
        //检索带回数据
        changeInputModel(val) {
            // console.log("返hui", val);
            if (val != "" || val != undefined) {
                if (this.seId == '853533363572736') {
                    for (let i = 0; i < this.sendDataInfo.descibSalesplicencedetailVo.length; i++) {
                        const element = this.sendDataInfo.descibSalesplicencedetailVo[i];
                        if (val.bgmId == element.bgmId) {
                            this.$message({
                                message: "当前单品已存在，请选择其它商品",
                                type: "error",
                            });
                            return false;
                        }
                    }
                    //赋值
                    this.sendDataInfo.descibSalesplicencedetailVo.push(val)
                } else {
                    if (this.seType == 'unitName') {
                        if (this.sendDataInfo.salesmanType == 0) {
                            this.sendDataInfo.unitId = val.cmId;
                            this.sendDataInfo.unitName = val.cmName;
                        } else {
                            this.sendDataInfo.unitId = val.smId;
                            this.sendDataInfo.unitName = val.smName;
                        }
                    } else {
                        this.paramValue(val)
                    }
                    this.$nextTick(() => {
                        this.nextFocus(this.seIndex)
                    })
                }
                this.DialogVisible = false;
                this.DialogVisible1 = false;
            } else {
                this.DialogVisible = false;
                this.DialogVisible1 = false;
                this.$message({
                    message: "检索失败",
                    type: "error",
                });
            }
        },
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.$set(this.sendDataInfo, item, val[item])
            })
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        //取消新增
        cancelAdd() {
            this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", 0);
                    // this.init();
                })
                .catch(() => { });
        },
        //确认新增
        async sendDataAction(sendDataInfo) {
            let flag = false;
            this.$refs["sendDataInfo"].validate((valid) => {
                if (valid) { } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
            if (flag) return false;
            let responseData;
            var sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            if (sendData.terType != 1) {
                sendData.bgmIds = []
            } else {
                sendData.bgmIds = this.sendDataInfo.descibSalesplicencedetailVo.map(item => item.bgmId)
                delete sendData.descibSalesplicencedetailVo
            }
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.addSalesmanInfo(sendData);
            } else {
                responseData = await this.$http.setSalesmanInfo(sendData);
            }

            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //初始化
        initActionBox() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
                if (key == 'descibSalesplicencedetailVo') {
                    this.sendDataInfo[key] = []
                }
            }
            this.$set(this.sendDataInfo, 'terType', 0)
            this.$set(this.sendDataInfo, 'isUsed', 1)
            this.$set(this.sendDataInfo, 'isIntercept', 1)
        },
        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.filterMainField()
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增对方业务员信息";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑对方业务员信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                this.sendDataInfo.salesmanType = Number(this.sendDataInfo.salesmanType)
                this.sendDataInfo.descibSalesplicencedetailVo.forEach(item => {
                    if (item.filePath != '') {
                        item.filePathArr = item.filePath.split(',')
                    } else {
                        item.filePathArr = []
                    }
                })
            } else {
                this.dataActionBox.boxTitle = "查看对方业务员信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                this.sendDataInfo.salesmanType = Number(this.sendDataInfo.salesmanType)
                this.sendDataInfo.descibSalesplicencedetailVo.forEach(item => {
                    if (item.filePath != '') {
                        item.filePathArr = item.filePath.split(',')
                    } else {
                        item.filePathArr = []
                    }
                })
            }
            this.dataActionBox.showStatus = true;
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight() - 50
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 16.7)
            })
        },
        //获取性别
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [1, 44],
            });
            if (responseData.status == 200) {
                this.geogRestData = responseData.result.dyxz;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取委托书名称
        async getCateDictionariesDatas() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [45],
            });
            if (responseData.status == 200) {
                this.dictionariesDatas = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            this.tabForm.push(JSON.parse(JSON.stringify(mainFormList[0])))
            this.tabForm[0].jurconfigform = []
            for (let index = 0; index < mainFormList[0].jurconfigform.length; index++) {
                if (mainFormList[0].jurconfigform[index].isShow == 1 || mainFormList[0].jurconfigform[index].entityField == "terScope") this.tabForm[0].jurconfigform.push(mainFormList[0].jurconfigform[index])
            }
            var arr = [{ entityField: "descibSalesplicencedetailVo" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.$set(this.sendDataInfo, 'terType', 0)
            this.$set(this.sendDataInfo, 'isUsed', 1)
            this.$set(this.sendDataInfo, 'isIntercept', 1)
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPartDictionariesData();
        this.getCateDictionariesDatas()
        this.imgUrl = this.$store.getters.getConfig.imgUrl;
        this.$nextTick(() => {
            this.openBox();
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.mxBox {
    margin: 10px;
    padding: 10px 0;
    margin-top: 0;
    padding-top: 0;
    /* border-top: 2px dashed #999;
		border-bottom: 2px dashed #999; */
}

.el-table .success-row {
    background: #f0f9eb;
}
</style>
<style scoped>
.image_label {
    cursor: pointer;
    padding: 6px 10px !important;
    font-size: 12px !important;
    background-color: #409eff;
    color: #ffffff;
    line-height: 14px;
    margin-right: 5px;
    border-radius: 3px;
}

::v-deep .el-image__error {
    font-size: 7px;
}

/* 上传图片 */
.upload {
    width: 200px;
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 5px;
}

.upload li {
    position: relative;
    width: 42px;
    height: 42px;
    margin-right: 5px;
    margin-bottom: 5px;
    border: 1px solid #dedede;
}

.upload .active_li {
    border: none;
}

.upload li .icon {
    color: #838383;
    font-size: 20px;
    margin: 10px 0 0 10px;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.upload li:hover .del {
    display: inline-block;
}

::v-deep .cus-image {
    width: 40px !important;
    height: 40px !important;
}

::v-deep .cus-image img {
    width: 40px !important;
    height: 40px !important;
}
</style>